/// <reference path="login.module.ts" />

module Meevo.Plugins.Login {
    "use strict";
    
    class LoginController {

        userName: string;
        password: string;
        passCode: string;
        passKey: string;
        showPassKeyFields: boolean;
        statusMessage: string;
        dataService: Meevo.Plugins.Login.LoginDataService;
        identityService: Meevo.Components.Common.IIdentityService;

        modalService: Meevo.Components.Modal.IModalService;

        static $inject = ["meevo.components.modal.ModalService", "meevo.components.common.IdentityService", "meevo.plugins.login.LoginDataService", "$scope"];

        constructor(modalService: Meevo.Components.Modal.IModalService, identityService: Meevo.Components.Common.IIdentityService, dataService: Meevo.Plugins.Login.LoginDataService, $scope: angular.IScope) {
            let login = this;
            login.dataService = dataService;
            login.identityService = identityService;

            login.passCode = dataService.getPassCode();
            
            $scope.$watch('[login.userName, login.password]', () => {
                login.statusMessage = "";

                if (login.userName === 'super' && login.password === 'super08*') {
                    login.showPassKeyFields = true;
                } else {
                    login.showPassKeyFields = false;
                }

            }, true);
        }

        submit(): void {
            //let response: Meevo.Plugins.Login.AuthenticationResponse;
            //this.statusMessage = "";

            //response = this.dataService.authenticate(this.userName, this.password, this.passCode, this.passKey);

            //if (response.status === 1) {
            //    this.identityService.setIdentity(response.identity);
            //    this.statusMessage = "Success!";
            //}
            //else if (response.status === 2) {
            //    this.statusMessage = "Error Code: " + response.status;
            //}
        }

    }
    
    angular.module("meevo.plugins.login")
        .controller("meevo.plugins.login.LoginController",
        LoginController);
}
